import { createAction, props } from '@ngrx/store';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { createRegisterActions } from 'src/app/common-components/register/models/register-actions';
import { BlockedPhoneNumberFilterOptions } from '../models/blocked-phone-number-filter-option';
import { BlockedPhoneNumberRegisterListItem } from '../models/blocked-phone-number-register-results.model';

const area = 'Blocked Phone Number Register';
export const blockedPhoneNumberRegisterAdapterActions = createRegisterActions<BlockedPhoneNumberRegisterListItem>(area);

export const refreshList = createAction(`[${area}] Refresh List`);

export const createBlockedPhoneNumber = createAction(`[${area}] Create Blocked Phone Number`);

export const blockedPhoneNumberRegisterInitialFilter = createAction(
   `[${area}] Initial Filter`,
   props<{ filters: BlockedPhoneNumberFilterOptions[] }>()
);

export const deleteBlockedPhoneNumber = createAction(
   '[Blocked Phone Number Detail] Delete Blocked Phone Number',
   props<{ blockedPhoneNumberId: number; phoneNumber: string }>()
);

export const deleteBlockedPhoneNumberSuccess = createAction(
   '[Blocked Phone Number Detail] Delete Blocked Phone Number Success',
   props<{ phoneNumber: string }>()
);

export const deleteBlockedPhoneNumberFailure = createAction(
   '[Blocked Phone Number Detail] Delete Blocked Phone Number Failure',
   props<SingleGraphError>()
);
